<template>
  <div>
    <string-color-icon
      :icon-class="value.iconClass ?? 'bi bi-square-fill'"
      :shadow="false"
      :value="value.color ?? value.title"
    ></string-color-icon
    >&nbsp;
    <Link
      v-if="isLinkable(route, routePrefix)"
      :href="route(`${routePrefix}.${value.resource}.show`, getParams())"
      active-class="active"
    >
      {{ displayValue() }}
    </Link>
    <span v-else :class="value.title === null ? 'text-muted' : ''">
      {{ displayValue() }}
    </span>
    <small v-if="showId === 'true' && value.id" class="text-muted"> (ID: {{ value.id }}) </small>
  </div>
</template>

<script>
import StringColorIcon from '@kanrisha/components/Icons/StringColorIcon';
import { Link } from '@inertiajs/vue3';

export default {
  components: {
    StringColorIcon,
    Link,
  },
  props: {
    value: { type: Object, default: () => {} },
    showId: { type: [Boolean, String], default: 'true' },
  },
  setup(props) {
    const displayValue = () => {
      if (props.value.title === '' || props.value.title === null) {
        return '(leer)';
      }

      return props.value.title;
    };

    const getParams = () => {
      let params = {};
      params[props.value.parameter] = props.value.id;
      return params;
    };

    const isLinkable = (route, routePrefix) => {
      if (!props.value.id) {
        return false;
      }

      return route().has(`${routePrefix}.${props.value.resource}.show`);
    };

    return {
      displayValue,
      getParams,
      isLinkable,
    };
  },
};
</script>
